import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const { isAuthenticated, currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleAuthAction = () => {
    if (isAuthenticated) {
      // Se estiver logado, fazer logout
      logout();
      navigate('/', { replace: true });
    } else {
      // Se não estiver logado, ir para login
      navigate('/login');
    }
  };

  const handleLogout = () => {
    logout();
    setShowUserMenu(false);
    navigate('/', { replace: true });
  };

  return (
    <header className="bg-primary shadow-md relative">
      <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center group">
          <img 
            src="/images/nome coopdelta.png" 
            alt="Logo COOPDELTA" 
            className="h-7 w-auto object-contain transition-all duration-300 group-hover:scale-105 drop-shadow-lg"
          />
        </Link>
        
        <div className="flex items-center gap-6">
          {/* Links de navegação */}
          <div className="flex gap-6">
            {isAuthenticated && (
              <Link 
                to="/contratos/novo" 
                className="text-white hover:text-white/80 font-medium transition-colors duration-200"
              >
                CONTRATOS
              </Link>
            )}
            
            {isAuthenticated && (
              <Link 
                to="/agua" 
                className="text-white hover:text-white/80 font-medium transition-colors duration-200"
              >
                ÁGUA
              </Link>
            )}
            
            <Link 
              to="/fotos" 
              className="text-white hover:text-white/80 font-medium transition-colors duration-200"
            >
              FOTOS
            </Link>
          </div>

          {/* Botão de Autenticação / Menu do Usuário */}
          {isAuthenticated ? (
            <div className="relative">
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="flex items-center space-x-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg transition-all duration-200"
              >
                <span className="font-medium">{currentUser}</span>
                <svg 
                  className={`w-4 h-4 transition-transform duration-200 ${showUserMenu ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {/* Menu dropdown */}
              {showUserMenu && (
                <>
                  {/* Overlay para fechar o menu */}
                  <div 
                    className="fixed inset-0 z-10" 
                    onClick={() => setShowUserMenu(false)}
                  ></div>
                  
                  {/* Menu */}
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20">
                    <div className="px-4 py-2 border-b border-gray-100">
                      <p className="text-sm text-gray-500">Logado como</p>
                      <p className="font-medium text-gray-800">{currentUser}</p>
                    </div>
                    
                    <Link
                      to="/contratos/novo"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                      onClick={() => setShowUserMenu(false)}
                    >
                      Gestão de Contratos
                    </Link>
                    
                    <Link
                      to="/agua"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                      onClick={() => setShowUserMenu(false)}
                    >
                      Qualidade da Água
                    </Link>
                    
                    <div className="border-t border-gray-100 mt-2 pt-2">
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                      >
                        Sair
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          ) : (
            <button
              onClick={handleAuthAction}
              className="bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg font-medium transition-all duration-200"
            >
              Administrador
            </button>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;